import {
    Box,
    Flex,
    FormControl,
    FormLabel,
    ModalOverlay,
} from '@chakra-ui/react';

import {
    Alert,
    AlertIcon,
    Button,
    Input,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
} from '@/components/v4';

import walkthroughIds from 'pages/telephony/numbers/walkthroughIds';
import { setFormattedValue } from 'utils/utils';

import useGetCurrentCompany from '@/queries/company/useGetCurrentCompany';
export default function EditModal({
    isOpen,
    onClose,
    handleSubmit,
    selectedRow: modalData,
    status,
}) {
    const { requestAvailableBlock } = walkthroughIds;
    const { data: currentCompanyData } = useGetCurrentCompany();
    const isLoading = status === 'loading';
    const formattedValue = setFormattedValue(modalData);
    return (
        <Modal closeOnOverlayClick isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent as="form" onSubmit={handleSubmit}>
                <ModalHeader>Requesting Available Block</ModalHeader>
                <ModalBody>
                    <Flex direction="column" gap={4}>
                        {modalData?.countryName && (
                            <FormControl>
                                <FormLabel>Country</FormLabel>
                                <Input
                                    id="country-name"
                                    placeholder="country"
                                    value={modalData?.countryName}
                                    isDisabled
                                    data-walkthroughid={
                                        requestAvailableBlock.country
                                    }
                                />
                            </FormControl>
                        )}
                        <FormControl>
                            <FormLabel>Number Range</FormLabel>
                            <Input
                                id="range"
                                placeholder="Number Range"
                                value={formattedValue}
                                isDisabled
                                data-walkthroughid={
                                    requestAvailableBlock.firstNumber
                                }
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Block Size</FormLabel>
                            <Input
                                id="block-size"
                                placeholder="Block Size"
                                value={modalData?.blockSize}
                                isDisabled
                                data-walkthroughid={
                                    requestAvailableBlock.blockSize
                                }
                            />
                        </FormControl>
                        <Box>
                            <Alert status="info">
                                <AlertIcon />
                                This constitutes an order and the block will be
                                added to your account. Charges based on your
                                plan will apply.
                            </Alert>
                        </Box>
                    </Flex>
                </ModalBody>
                <ModalFooter justifyContent="space-evenly">
                    <Button onClick={onClose} variant="outline" w={128}>
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        colorScheme="messenger"
                        w={128}
                        isDisabled={isLoading || !currentCompanyData?.approved}
                        _focus={{
                            boxShadow:
                                '0 0 0 1px var(--chakra-colors-blue-500)',
                        }}>
                        {isLoading ? 'Submitting...' : 'Submit'}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
